import { render, staticRenderFns } from "./CreateContractView.vue?vue&type=template&id=a08ccf64&"
import script from "./CreateContractView.vue?vue&type=script&lang=js&"
export * from "./CreateContractView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports